module.exports = __webpack_public_path__ + "static/media/comment-dots.d4a4fc2d.svg";